import { create } from 'zustand';

const MOCK_BASE = (process.env.REACT_APP_CLOUD_MOCK_BASE_URL || '').replace(/\/$/, '');

/**
 * The SERVER's `base_url` wins.
 *
 * Only the node that serves the mock knows which host it answers on
 * (mock-de1/mock-us1 today, more as regions are added), so a compile-time
 * client constant cannot be right for everyone. It was also silently wrong in
 * production: `.env` sets REACT_APP_CLOUD_MOCK_BASE_URL to localhost and
 * `.env.production` never overrode it, so every release rebuilt the server's
 * correct URL into `http://localhost:4000/mock/<token>` and handed users a
 * dead link.
 *
 * The env var remains as a dev fallback for running against a local Phoenix
 * whose own default may not match the port you booted on.
 */
export function buildBaseUrl(token, serverBaseUrl) {
  if (serverBaseUrl) return String(serverBaseUrl).replace(/\/$/, '');
  if (!token) return null;
  return MOCK_BASE ? `${MOCK_BASE}/${token}` : null;
}

export const useCloudMockStore = create((set) => ({
  enabled: false,
  token: null,
  baseUrl: null,
  setStatus: (status) =>
    set({
      enabled: !!status?.enabled,
      token: status?.token ?? null,
      baseUrl: buildBaseUrl(status?.token, status?.base_url),
    }),
  reset: () => set({ enabled: false, token: null, baseUrl: null }),
}));
